module.exports = __webpack_public_path__ + "img/p4.f79779c.png";